import {
  List,
  ListItemButton,
  ListItemIcon,
  SvgIconTypeMap,
  ListItemText,
  Button,
} from "@mui/material";
import { OverridableComponent } from "@mui/material/OverridableComponent";
import { FC } from "react";
import { NavLink } from "react-router-dom";
import { classes } from "./sidebar.styles";

export type MenuItem = {
  label: string;
  link?: string;
  action?: () => void;
  icon?: OverridableComponent<SvgIconTypeMap> & { muiName: string };
};

type Props = {
  menuItems: MenuItem[];
  onItemClick?: () => void;
};

export const Sidebar: FC<Props> = ({ menuItems, onItemClick }) => {
  const MenuItem = ({ item }: { item: MenuItem }) => (
    <ListItemButton
      sx={classes.listItem}
      component={item.link ? NavLink : Button}
      disableRipple={true}
      to={item.link || ""}
      onClick={() => {
        if (onItemClick) {
          onItemClick();
        }

        if (item.action) {
          item.action();
        }
      }}
    >
      <ListItemIcon>{item.icon && <item.icon color="primary" />}</ListItemIcon>
      <ListItemText primary={item.label} />
    </ListItemButton>
  );

  return (
    <List sx={classes.list}>
      {menuItems.map((item) => (
        <MenuItem key={item.label} item={item} />
      ))}
    </List>
  );
};
